import { get } from "../../../services/httpClient";
import { IcbtPaymentData } from "./types";

export const getIcbtPaymentsInDateRange = (dateFrom: number, dateTo: number) =>
  get<{ data: IcbtPaymentData[] }>(
    `answers/icbt-fee?fromDate=${dateFrom}&toDate=${dateTo}`,
  );
